import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTokenByShortCode } from "../APIs/externalReferralApi";

export default function ClaimCodePage() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = code.trim().toUpperCase();
    if (!trimmed) return;
    setLoading(true);
    setError("");
    try {
      const data = await getTokenByShortCode(trimmed);
      navigate(`/claim-referral?token=${encodeURIComponent(data.token)}`);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 404)
        setError("Invalid referral code — please check and try again.");
      else if (status === 410) setError("This referral code has expired.");
      else setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-xl shadow-md w-full max-w-md p-8">
        {/* Logo / Brand */}
        <div className="text-center mb-6">
          <p className="text-2xl font-bold text-green-600">MedMaze Health</p>
          <p className="text-sm text-gray-500 mt-1">
            Referral Management Platform
          </p>
        </div>

        <h1 className="text-lg font-semibold text-gray-800 mb-1">
          Enter your Referral Code
        </h1>
        <p className="text-sm text-gray-500 mb-5">
          Find this code in the fax you received from the referring office.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            className="w-full border rounded-lg px-4 py-3 text-sm font-mono uppercase tracking-widest focus:outline-none focus:ring-2 focus:ring-green-400"
            placeholder="MZ-XXXX-XXX"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={12}
            autoFocus
          />
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <button
            type="submit"
            disabled={loading || !code.trim()}
            className="w-full py-3 rounded-lg bg-green-600 text-white font-semibold text-sm disabled:opacity-40 hover:bg-green-700 transition"
          >
            {loading ? "Looking up..." : "Continue"}
          </button>
        </form>

        <p className="text-xs text-gray-400 text-center mt-6">
          You can also scan the QR code on the fax with your phone camera.
        </p>
      </div>
    </div>
  );
}
